import React, { Component } from 'react';
import axios from 'axios';
import TextInput from '../common/inputs/textInput';
import Loading from '../common/loading';
import NotificationManager from '../../utils/notificationManager';
import ToggleInput from '../common/inputs/toggleInput';

// const SHOULD_HIDE = true;

export default class DeploymentSettings extends Component {
    state = {
        deploymentSettings: {
            host: '',
            notification_email: '',
            notification_email_pass: '',
            notification_email_auth_required: true,
            notification_email_port: '',
            notification_email_secure: false,
            notification_email_host: '',
            notification_email_tls: false,
            notification_email_from: '',
            email_alert_recipients: '',
            email_alerts_device_connect: false,
            email_alerts_device_disconnect: false,
            connection_type: 'directIp',
            license_key: '',
            jwt_secret: '',
            salt: '',
            saml_certificate: '',
            saml_private_key: '',
            allow_user_registration: false,
            require_admin_approval: false,
            // New fields
            listen_address: '80',
            forward_port_80_to_443: false,
            connection_security: 'none',
            tls_cert: '',
            tls_key: '',
            // host_url: ''
        },
        testEmailAddress: '',
        superAdmin: {
            email: '',
            password: '',
            confirmPassword: '',
        },
        superAdminErrorMessage: '',
        loading: false,
        hasChanges: false,
        loadingSuperAdmin: false,
        loadedSuperAdmins: [],
        superAdminUserExists: false,
        testingEmail: false,
    };

    componentDidMount() {
        this.fetchDeploymentSettings();
        this.fetchSuperAdmin();
    }

    fetchSuperAdmin = async () => {
        try {
            const res = await axios.get('/v1/users', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            console.log(res)
            this.setState({
                superAdminUserExists: res.data.data.some(user => user.isDeploymentAdministrator),
                loadedSuperAdmins: res.data.data.filter(user => user.isDeploymentAdministrator),
            })
            // this.setState({ superAdmin: res.data });
        } catch (err) {
            console.error('Error fetching super admin', err);
        }
    }

    fetchDeploymentSettings = async () => {
        try {
            const res = await axios.get('/v1/deployment-settings', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const incomingSettings = res.data || {};
            this.setState({
                deploymentSettings: {
                    ...this.state.deploymentSettings,
                    ...incomingSettings,
                    notification_email_auth_required: incomingSettings.notification_email_auth_required !== false,
                    email_alert_recipients: incomingSettings.email_alert_recipients || '',
                    email_alerts_device_connect: Boolean(incomingSettings.email_alerts_device_connect),
                    email_alerts_device_disconnect: Boolean(incomingSettings.email_alerts_device_disconnect),
                },
                hasChanges: false
            });

        } catch (err) {
            console.log(err)
            console.log("NOO!!!!!")
            if (err.response && err.response.status === 401) {
                // redirect to login

                console.log(this.props)
                this.props.history.replace("/login")
            }
            console.error('Error fetching deployment settings', err);
        }
    };

    handleChange = (field, value) => {
        this.setState({
            deploymentSettings: {
                ...this.state.deploymentSettings,
                [field]: value
            },
            hasChanges: true
        });
    };

    handleSuperAdminChange = (field, value) => {
        this.setState({
            superAdmin: {
                ...this.state.superAdmin,
                [field]: value
            }
        });
    };

    handleSubmit = () => {
        this.setState({ loading: true });
        console.log("processing submit");
        const {
            host_url,
            ...pkg
        } = this.state.deploymentSettings
        axios.put('/v1/deployment-settings', pkg, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
            .then(result => {
                NotificationManager.success('Deployment settings updated successfully');
                this.setState({ hasChanges: false });
            })
            .catch(err => {
                // NotificationManager.alert("Error updating deployment settings", "Error")
                // console.log(NotificationManager)
                console.error('Error updating deployment settings', err);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };
    handleSuperAdminSubmit = async () => {
        if (this.state.superAdmin.password !== this.state.superAdmin.confirmPassword) {
            NotificationManager.alert('Passwords do not match');
            return;
        }
        this.setState({ loadingSuperAdmin: true, superAdminErrorMessage: '' });
        try {
            const superAdminUser = await axios.post('/v1/auth/register', {
                email: this.state.superAdmin.email,
                password: this.state.superAdmin.password,
                // isEnterpriseAdmin: true
            }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            localStorage.setItem("token", superAdminUser.data.token)
            localStorage.setItem("userId", superAdminUser.data.user.user_id)

            this.setState({
                loadedSuperAdmins: [...this.state.loadedSuperAdmins, superAdminUser.data.user],
                superAdminUserExists: true
            })
            NotificationManager.success('Super admin created successfully');

        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                this.setState({
                    superAdminErrorMessage: err.response.data.message
                })
            }
            // NotificationManager.alert('Error creating super admin');
            console.error('Error creating super admin', err);
        } finally {
            this.setState({ loadingSuperAdmin: false });
        }
    };

    testEmail = async () => {
        const trimmedEmail = (this.state.testEmailAddress || '').trim();

        if (!trimmedEmail) {
            NotificationManager.alert('Please enter a test email address.');
            return;
        }

        this.setState({ testingEmail: true });

        try {
            await axios.post('/v1/deployment-settings/email-test', {
                testEmail: trimmedEmail
            }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            NotificationManager.success('Test email sent successfully');
        } catch (err) {
            const errorMessage = err.response && err.response.data && err.response.data.message;
            if (errorMessage) {
                NotificationManager.alert(errorMessage);
            } else {
                NotificationManager.alert('Error sending test email.');
            }
        } finally {
            this.setState({ testingEmail: false });
        }
    }

    render() {
        const {
            deploymentSettings,
            superAdmin,
            loading,
            hasChanges,
            loadingSuperAdmin
        } = this.state;
        const { testingEmail } = this.state;

        const pathname = this.props.location.pathname;
        const showAdminSide = pathname === "/deployment/administrator" || pathname === "/deployment-settings";
        const showGeneralSettingsSide = pathname === "/deployment/settings" || pathname === "/deployment-settings";
        const showEmailSettingsSide = pathname === "/deployment/email";

        const envManagedRows = [
            { label: 'Server Host', value: deploymentSettings.host || '—' },
            { label: 'Public URL', value: deploymentSettings.host_url || '—' },
            { label: 'Listen Port', value: deploymentSettings.listen_address || '—' },
            {
                label: 'Forward Port 80 -> 443',
                value: deploymentSettings.forward_port_80_to_443 ? 'Enabled' : 'Disabled'
            },
            {
                label: 'Connection Security',
                value: (deploymentSettings.connection_security || 'none').toUpperCase()
            },
            {
                label: 'TLS Certificate',
                value: deploymentSettings.tls_cert ? 'Configured via environment' : 'Not configured'
            },
            {
                label: 'TLS Key',
                value: deploymentSettings.tls_key ? 'Configured via environment' : 'Not configured'
            }
        ];

        const renderGeneralSettings = () => (
            <React.Fragment>
                <div className="cell">
                    <h4>General Settings</h4>
                    <div
                        style={{
                            borderBottom: '1px solid #e0e0e0',
                            paddingBottom: '10px',
                        }}
                    />
                </div>
                <div className="cell large-7">
                    <div className="callout secondary">
                        Deployment networking is managed via your deployment environment (.env / container settings). Update the environment variables to change these values.
                    </div>
                    <table className="stack">
                        <tbody>
                            {envManagedRows.map(row => (
                                <tr key={row.label}>
                                    <th style={{ width: '40%' }}>{row.label}</th>
                                    <td>{row.value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        );

        const renderEmailSettings = () => (
            <React.Fragment>
                {/* <div className="cell">
                    <h4>Email Settings</h4>
                    <div
                        style={{
                            borderBottom: '1px solid #e0e0e0',
                            paddingBottom: '10px',
                        }}
                    />
                </div> */}
                <div className="cell large-6">

                    <h4>Email Settings</h4>
                    <p>Configure the SMTP server Synaccess Cloud should use when sending notifications.</p>
                    <div
                        style={{
                            borderBottom: '1px solid #e0e0e0',
                            paddingBottom: '10px',
                        }}
                    />
                    <ToggleInput
                        label="SMTP Authentication Required"
                        value={deploymentSettings.notification_email_auth_required}
                        callback={(value) => this.handleChange('notification_email_auth_required', value)}
                        description="Disable if your SMTP server accepts email without a username and password."
                        id="TOGGLE_EMAIL_AUTH_REQUIRED"
                    />
                    <TextInput
                        label="Account Username"
                        value={deploymentSettings.notification_email}
                        callback={(value) => this.handleChange('notification_email', value)}
                        disabled={!deploymentSettings.notification_email_auth_required}
                        description="Enter the username used to log in to the SMTP server."
                    />
                    <TextInput
                        label="Account Password"
                        value={deploymentSettings.notification_email_pass}
                        callback={(value) => this.handleChange('notification_email_pass', value)}
                        type="password"
                        disabled={!deploymentSettings.notification_email_auth_required}
                    />
                    <TextInput
                        label="SMTP Port"
                        value={deploymentSettings.notification_email_port}
                        callback={(value) => this.handleChange('notification_email_port', value)}
                        description="Enter the port for the email server."
                    />
                    <div className="grid-x">
                        <div className="cell large-6">
                            <ToggleInput
                                label="Use Implicit TLS"
                                value={deploymentSettings.notification_email_secure}
                                callback={(value) => this.handleChange('notification_email_secure', value)}
                                description="Enable for TLS from the start of the connection (usually port 465). Disable for STARTTLS (usually port 587) or an unencrypted relay."
                                id="TOGGLE_EMAIL_SECURE"
                            />
                        </div>
                        <div className="cell large-6">
                            <ToggleInput
                                label="Verify TLS Certificate"
                                value={deploymentSettings.notification_email_tls}
                                callback={(value) => this.handleChange('notification_email_tls', value)}
                                description="Check that the SMTP server's TLS certificate is trusted."
                                id="toggle_tls_email"
                            />
                        </div>
                    </div>
                    <TextInput
                        label="SMTP Server IP Address/URL"
                        value={deploymentSettings.notification_email_host}
                        callback={(value) => this.handleChange('notification_email_host', value)}
                        description="Enter the host for the email server. (example: smtp.gmail.com)."
                    />
                    <TextInput
                        label="From Email Address"
                        value={deploymentSettings.notification_email_from}
                        callback={(value) => this.handleChange('notification_email_from', value)}
                        description="Sender email address for notifications. Required when no account email address is configured."
                    />
                                        <button className="button" onClick={this.handleSubmit} disabled={!hasChanges || loading}>
                        {loading ? <Loading /> : 'Save Changes'}
                    </button>
                    <div
                        style={{
                            borderBottom: '1px solid #e0e0e0',
                            paddingBottom: '10px',
                            marginBottom: "20px"
                        }}
                    />
                    <div className="grid-x grid-margin-x">
                        <div className="cell large-8">
                            <TextInput
                                label="Test Email Address"
                                value={this.state.testEmailAddress}
                                callback={(value) => this.setState({ testEmailAddress: value })}
                                description="Send a test email to verify your SMTP settings."
                            />
                        </div>
                        <div className="cell large-4" style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <button
                                className="button secondary"
                                onClick={this.testEmail}
                                disabled={testingEmail}
                                style={{ width: '100%' }}
                            >
                                {testingEmail ? <Loading /> : 'Send Test Email'}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="cell large-6">
                    <h4>Email Alerts</h4>
                    <p>Select which device events should send an email and who should receive them.</p>
                    <div
                        style={{
                            borderBottom: '1px solid #e0e0e0',
                            paddingBottom: '10px',
                        }}
                    />
                    <div className="grid-x grid-margin-x">
                        <div className="cell large-6">
                            <ToggleInput
                                label="Device connect alerts"
                                value={deploymentSettings.email_alerts_device_connect}
                                callback={(value) => this.handleChange('email_alerts_device_connect', value)}
                                description="Send an email each time a device connects."
                                id="toggle_email_alert_connect"
                            />
                        </div>
                        <div className="cell large-6">
                            <ToggleInput
                                label="Device disconnect alerts"
                                value={deploymentSettings.email_alerts_device_disconnect}
                                callback={(value) => this.handleChange('email_alerts_device_disconnect', value)}
                                description="Send an email when a device disconnects."
                                id="toggle_email_alert_disconnect"
                            />
                        </div>
                    </div>
                    <TextInput
                        label="Alert Recipients"
                        value={deploymentSettings.email_alert_recipients}
                        callback={(value) => this.handleChange('email_alert_recipients', value)}
                        description="Comma-separated list of email addresses that should receive device alerts."
                        placeholder="admin@example.com, ops@example.com"
                    />
                    <button className="button" onClick={this.handleSubmit} disabled={!hasChanges || loading}>
                        {loading ? <Loading /> : 'Save Changes'}
                    </button>
                   
                </div>
            </React.Fragment>
        );
        return (
            <React.Fragment>
                <div className="grid-container">
                    <div className="grid-x grid-padding-x grid-padding-y grid-margin-x">
                        {showGeneralSettingsSide && renderGeneralSettings()}
                        {showEmailSettingsSide && renderEmailSettings()}
                        {showAdminSide && <div className="cell large-5">
                            <h4>Administrator Setup</h4>
                            <p>The Deployment Administrator for this deployment can manage all settings and users in the system.</p>
                            {this.state.superAdminUserExists ? (
                                <div>
                                    <div style={{ marginBottom: '10px' }}><b>Current Super Admin</b></div>
                                    <div>
                                        {this.state.loadedSuperAdmins.map(user => (
                                            <div key={user.user_id}>
                                                <div>
                                                    <input value={user.email_id} readOnly />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                        <div className="button">
                                            <a href="/">
                                                <div style={{ color: "white" }}>
                                                    Go to Synaccess Cloud Portal
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <TextInput
                                        label="Super Admin Email"
                                        value={superAdmin.email}
                                        callback={(value) => this.handleSuperAdminChange('email', value)}
                                    />
                                    <TextInput
                                        label="Super Admin Password"
                                        value={superAdmin.password}
                                        callback={(value) => this.handleSuperAdminChange('password', value)}
                                        type="password"
                                    />
                                    <TextInput
                                        label="Confirm Password"
                                        value={superAdmin.confirmPassword}
                                        callback={(value) => this.handleSuperAdminChange('confirmPassword', value)}
                                        type="password"
                                    />
                                    <div style={{ marginBottom: "20px" }}>
                                        {[{
                                            name: "2 lowercase characters required",
                                            valid: /[a-z].*[a-z]/.test(superAdmin.password)
                                        }, {
                                            name: "2 uppercase characters required",
                                            valid: /[A-Z].*[A-Z]/.test(superAdmin.password)
                                        }, {
                                            name: "2 number characters required",
                                            valid: /[0-9].*[0-9]/.test(superAdmin.password)
                                        }, {
                                            name: "2 special characters required",
                                            valid: /[!@#$%^&*;].*[!@#$%^&*;]/.test(superAdmin.password)
                                        }].map(validation => (
                                            <div
                                                key={validation.name}
                                                style={{
                                                    color: validation.valid ? "forestgreen" : "#666",
                                                    display: 'flex',
                                                    paddingBottom: "10px",
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <i className="material-icons">{validation.valid ? "check" : "cancel"}</i>
                                                <span>{validation.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <div style={{ color: "red", marginBottom: "20px", whiteSpace: "pre-line" }}>
                                        {this.state.superAdminErrorMessage.split(',').join(',\n')}
                                    </div>
                                    <button className="button" onClick={this.handleSuperAdminSubmit} disabled={loadingSuperAdmin}>
                                        {loadingSuperAdmin ? <Loading /> : 'Create Super Admin'}
                                    </button>
                                </div>
                            )}
                        </div>}
                    </div>
                </div>
            </React.Fragment>
        );
    }
    
}
